import { Skeleton } from '@/components/ui/skeleton';

export function PageLoader() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="border-b border-border/40 px-6 py-3">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <Skeleton className="h-7 w-24" />
          <Skeleton className="h-10 w-36 rounded-lg" />
        </div>
      </div>
      <div className="flex-1 px-6 py-8">
        <div className="mx-auto max-w-6xl space-y-6">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-72" />
          <div className="grid gap-4 md:grid-cols-3">
            <Skeleton className="h-32 rounded-xl" />
            <Skeleton className="h-32 rounded-xl" />
            <Skeleton className="h-32 rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}
